document.addEventListener('DOMContentLoaded', () => {
  const valuesHeading = document.getElementById('shopify-section-section_html_xGy3xt');
  const pricingStory = document.querySelector('.ss-home-pricing');
  if (valuesHeading && pricingStory) valuesHeading.insertAdjacentElement('afterend', pricingStory);

  const socialEmbeds = document.querySelectorAll('[data-instagram-widget], [data-social-embed]');
  socialEmbeds.forEach(embed => {
    const frame = embed.querySelector('iframe[data-src]');
    if (!frame || frame.src) return;
    const load = () => {
      frame.src = frame.dataset.src;
      frame.hidden = false;
      frame.style.display = '';
      embed.querySelector('.instagram-deferred__placeholder')?.remove();
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) { observer.disconnect(); load(); }
      }, { rootMargin: '300px 0px' });
      observer.observe(embed);
    } else window.addEventListener('load', load, { once: true });
  });

  document.querySelectorAll('.owl-carousel[data-autoplay], .owl-carousel').forEach(carousel => {
    let visible = false;
    const sync = () => {
      if (!window.jQuery) return;
      window.jQuery(carousel).trigger(visible && !document.hidden ? 'play.owl.autoplay' : 'stop.owl.autoplay');
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      sync();
    }, { threshold: 0.05 });
    observer.observe(carousel);
    document.addEventListener('visibilitychange', sync);
  });
});
